module.exports = __webpack_public_path__ + "components/rewards/armadillo/static/logo-189808180cda4168b116d66159d83f34.webp";